<header
  (cslClickOutside)="toggleMenu(false)"
  class="border-blue-750 absolute z-[11] w-full rounded-3xl border bg-blue-800 p-2 text-white md:px-4 md:py-1"
>
  <div class="flex items-center">
    <a
      [href]="homePageUrl"
      gtmLinkClick="header_click"
      gtmText="Casella Logo"
      class="focus:rounded-[10px] focus:ring-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
    >
      <img
        alt="Casella Logo"
        height="76"
        ngSrc="images/logo.svg"
        priority="true"
        width="180"
        data-testid="header-logo"
      />
    </a>
    <!--Desktop menu items-->
    <nav class="ml-6 hidden gap-2 md:flex">
      @for (item of navItems; track item) {
        <a
          [routerLink]="item.url"
          routerLinkActive="hidden"
          [routerLinkActiveOptions]="{ exact: true }"
          gtmLinkClick="header_click"
          class="cursor-pointer px-6 py-[15px] hover:text-green-400 hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white active:text-green-700 active:no-underline"
        >
          {{ item.label }}
        </a>
      }
    </nav>
    <a
      href="{{ homePageUrl }}"
      target="”_blank”"
      gtmLinkClick="header_click"
      class="ml-auto hidden text-green-600 md:flex"
      cslButton="primary-link"
      [inverted]="true"
    >
      <span data-testid="header-go-to-homepage"> Go to Homepage </span>
      <csl-svg-icon [name]="icons.ArrowRight" class="block size-6 -rotate-45"></csl-svg-icon>
    </a>
    <button
      (click)="toggleMenu(!isOpen())"
      class="ml-auto focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white md:hidden"
      cslButton="primary-link"
      [inverted]="true"
      type="button"
      aria-label="Mobile menu"
    >
      <csl-svg-icon [name]="isOpen() ? icons.Cross : icons.Menu" class="block size-6"></csl-svg-icon>
    </button>
  </div>
  <!--Mobile menu items-->
  @if (isOpen()) {
    <nav class="my-28 flex flex-col items-center justify-center gap-6 md:hidden" aria-label="Mobile menu items">
      @for (item of navItems; track item) {
        <a
          [routerLink]="item.url"
          routerLinkActive="hidden"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="toggleMenu(false)"
          class="cursor-pointer px-6 py-[15px] hover:text-green-400 hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white active:text-green-700 active:no-underline"
          >{{ item.label }}</a
        >
      }
      <a
        (click)="toggleMenu(false)"
        href="{{ homePageUrl }}"
        class="focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
        target="”_blank”"
        gtmLinkClick="header_click"
        cslButton="primary-link"
        [inverted]="true"
      >
        Go to Homepage
      </a>
    </nav>
  }
</header>
<!--Overlay-->
@if (isOpen()) {
  <div class="bg-blue-825 fixed left-0 top-0 z-[1] h-screen w-screen bg-opacity-[0.57] backdrop-blur"></div>
}
